import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { } from '../Features/SmsGatewaysdata';
import { RootState, AppDispatch } from '../Appstore/store';
import { setIsLoading } from '../Features/loadingSlice';
import { formatDate } from '../helper';
import { SmsCampaignListRecord } from '../Components/Viewsmscampaignlist';
import { GetallSmsCampaignListReport } from '../Features/reports/Smscampaignlistreport';
import { IoMdArrowRoundBack } from 'react-icons/io';
import { GetallSmsCampaignReportDawnlaod } from '../Features/Smscampaignreports/Smscampaignreportdawnload';
import { RenderPaginationButtons } from './Paginations';
import { BiExport } from "react-icons/bi";
import { GetallSmsCampaignListReports } from '../Features/Smscampaignreports/Smscampaignlist';
import { MdClear } from "react-icons/md";


function Viewsmscampaignreports() {
    const [currentPage, setCurrentPage] = useState<number>(1);
    const limit = 10;
    const [isExporting, setIsExporting] = useState(false);
    const dispatch = useDispatch<AppDispatch>();
    const { id }: any = useParams();
    const navigate = useNavigate();

    const { smscampaignlistreportdata, info, loading, error } = useSelector((state: RootState) => state.smscampaignlistreport);
    const recordreport: SmsCampaignListRecord | any = smscampaignlistreportdata || [];

    const [smsGatewayName, setsmsGatewayName] = useState('');
    const [gatewayName, setGatewayName] = useState(0);
    const [gatewayNumber, setGatewayNumber] = useState('');
    const [receiverNumber, setReceiverNumber] = useState('');
    const [status, setStatus] = useState('');
    const [retryStatus, setretryStatus] = useState("");
    const [attempt, setAttempt] = useState('');

    useEffect(() => {
        const timer = setTimeout(() => {
            dispatch(GetallSmsCampaignListReport({
                id: id,
                sms_gateway_name: smsGatewayName,
                sms_gateway: gatewayName,
                gateway_number: gatewayNumber,
                receiver_number: receiverNumber,
                status: status ? parseInt(status, 10) : undefined,
                retry_status: retryStatus ? parseInt(retryStatus, 10) : undefined,
                attempt: attempt ? parseInt(attempt, 10) : undefined,
                limit: limit,
                page: currentPage,
            }));
            setIsLoading(true)
        }, 0);

        return () => clearTimeout(timer);
    }, [dispatch, currentPage, limit, id]);

    useEffect(() => {
        const debFN = setTimeout(() => {
            dispatch(GetallSmsCampaignListReport({
                id: id,
                sms_gateway_name: smsGatewayName,
                sms_gateway: gatewayName,
                gateway_number: gatewayNumber,
                receiver_number: receiverNumber,
                status: status ? parseInt(status, 10) : undefined,
                retry_status: retryStatus ? parseInt(retryStatus, 10) : undefined,
                attempt: attempt ? parseInt(attempt, 10) : undefined,
                limit: limit,
                page: currentPage,
            }));
        }, 500);

        return () => clearTimeout(debFN);
    }, [smsGatewayName, gatewayName, gatewayNumber, receiverNumber, status, retryStatus, attempt]);

    const handleDownload = () => {
        setIsExporting(true);
        dispatch(GetallSmsCampaignReportDawnlaod({
            id: id,
            sms_gateway_name: smsGatewayName,
            sms_gateway: gatewayName,
            gateway_number: gatewayNumber,
            receiver_number: receiverNumber,
            status: status ? parseInt(status, 10) : undefined,
            retry_status: retryStatus ? parseInt(retryStatus, 10) : undefined,
            attempt: attempt ? parseInt(attempt, 10) : undefined,
            limit: limit,
            page: currentPage,
        }))
            .then((response) => {
                if (response.meta.requestStatus === 'fulfilled' && response.payload instanceof Blob) {
                    const blob = response.payload;

                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = `Sms-Campaign-Report_${new Date().toISOString()}.xlsx`;

                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            })
            .finally(() => {
                setTimeout(() => {
                    setIsExporting(false);;
                }, 500);
            });
    };

    const handlePageChange = (page: number) => {
        if (page > 0 && page <= (info?.total_page || 1)) {
            setCurrentPage(page);
        }
    };

    const handlebackbutton = () => {
        navigate(-1);
        dispatch(GetallSmsCampaignListReports({ search: '', page: 1, limit: 10 }))
    }

    const handleClearSearchFilter = () => {
        setsmsGatewayName('');
        setGatewayName(0);
        setGatewayNumber('');
        setReceiverNumber('');
        setStatus('');
        setretryStatus("");
        setAttempt('');
        setCurrentPage(1);
    };

    if (error) {
        <div>No found data</div>
    }

    return (

        <div className="wrapper">
            <div className="content-wrapper">
                <section className="content">
                    <div className="container-fluid">
                        <div className="card mt-4">
                            <div className="rounded-top bg-white p-3 d-md-flex justify-content-sm-between">
                                <div className='d-flex justify-content-between w-100'>
                                    <h2 className="mb-0 fs-3">SMS Campaign Reports</h2>
                                    <div className='d-flex'>
                                        <button onClick={handleClearSearchFilter} className='d-md-block d-none width-reports-header-buttons mt-md-0 mt-2 btn btn-secondary d-flex align-items-center' style={{ width: 122 }}>
                                            <MdClear className='fs-5' />
                                            Clear Filter
                                        </button>
                                        <button
                                            onClick={handleDownload}
                                            className='d-md-block d-none width-reports-header-buttons btn btn-info bg-success ms-2 text-white mt-md-0 mt-2 d-flex align-items-center fw-semibold'
                                            disabled={isExporting}
                                        >
                                            <BiExport className='fs-5' />
                                            {isExporting ? 'Exporting...' : `Export `}
                                        </button>
                                        <div>
                                            <button onClick={handlebackbutton} className='btn btn-info ms-md-2 mt-md-0 text-white d-flex align-items-center fw-semibold'>
                                                <IoMdArrowRoundBack /> Back
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className='d-flex d-md-none flex-wrap justify-content-between'>
                                    <div className='w-50'>
                                        <button onClick={handleClearSearchFilter} className='w-100 mt-md-0 mt-3 btn btn-secondary d-flex align-items-center justify-content-center' style={{ width: 122 }}>
                                            <MdClear className='fs-5' />
                                            Clear Filter
                                        </button>
                                    </div>
                                    <div className='w-50'>
                                        <button
                                            onClick={handleDownload}
                                            className='w-100 btn btn-info bg-success ms-2 text-white mt-md-0 mt-3 d-flex align-items-center fw-semibold justify-content-center'
                                            disabled={isExporting}
                                        >
                                            <BiExport className='fs-5' />
                                            {isExporting ? 'Exporting...' : `Export `}
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body border-start-0 border-end-0 p-0">
                                <>
                                    <div className='table-responsive'>
                                        <table className="table table-hover table-bordered text-nowrap">
                                            <thead>
                                                <tr>
                                                    <th className='ps-3 sr-no'>SR No</th>
                                                    <th>Sms Gateway Name</th>
                                                    <th>Gateway Name</th>
                                                    <th>From Number</th>
                                                    <th>To Number</th>
                                                    <th className='text-center status' style={{ minWidth: 151 }}>Status</th>
                                                    <th className='text-center' style={{ width: 151 }}>Attempt</th>
                                                    <th className='text-center' style={{ minWidth: 130 }}>Error Code</th>
                                                    <th className='text-center'>Error Message</th>
                                                    <th className="text-center status" style={{ minWidth: 151 }}>Retry Status</th>
                                                    <th className="text-center" style={{ minWidth: 170 }}>Retry At</th>
                                                    <th className="text-center" style={{ minWidth: 130 }}>Retry Error Code</th>
                                                    <th className="text-center">Retry Error Message</th>
                                                    <th className='createdat text-center'>CreatedAt</th>
                                                </tr>
                                                <tr>
                                                    <th className='ps-3'></th>
                                                    <th>
                                                        <input
                                                            type="text"
                                                            placeholder="Search Sms Gateway Name"
                                                            onChange={(e) => setsmsGatewayName(e.target.value.trim())}
                                                            value={smsGatewayName}
                                                            className="form-control"
                                                        />
                                                    </th>
                                                    <th>
                                                        <select
                                                            onChange={(e: any) => setGatewayName(e.target.value)}
                                                            className="form-control"
                                                            value={gatewayName}
                                                        >
                                                            <option value="">All Gateways</option>
                                                            <option value="1">Twilio</option>
                                                            <option value="2">Telnyx</option>
                                                        </select>
                                                    </th>

                                                    <th>
                                                        <input
                                                            type="text"
                                                            placeholder="Search Gateway Number"
                                                            onChange={(e) => setGatewayNumber(e.target.value.trim())}
                                                            value={gatewayNumber}
                                                            className="form-control"
                                                        />
                                                    </th>
                                                    <th>
                                                        <input
                                                            type="text"
                                                            placeholder="Search Receiver Number"
                                                            onChange={(e) => setReceiverNumber(e.target.value.trim())}
                                                            value={receiverNumber}
                                                            className="form-control"
                                                        />
                                                    </th>
                                                    <th>
                                                        <select
                                                            onChange={(e) => setStatus(e.target.value)}
                                                            className="form-control"
                                                            value={status}
                                                        >
                                                            <option value="">All Status</option>
                                                            <option value="0">Pending</option>
                                                            <option value="1">Sent</option>
                                                            <option value="2">Delivered</option>
                                                            <option value="3">Undelivered</option>
                                                            <option value="4">Failed</option>
                                                            <option value="5">Delivery Unknown</option>
                                                            <option value="6">Delivery Unconfirmed</option>
                                                            <option value="7">Unknown Gateway</option>
                                                        </select>
                                                    </th>

                                                    <th>
                                                        <input
                                                            type="text"
                                                            placeholder="Search Attempt"
                                                            onChange={(e) => setAttempt(e.target.value.trim())}
                                                            value={attempt}
                                                            className="form-control"
                                                        />
                                                    </th>
                                                    <th></th>
                                                    <th></th>
                                                    <th>
                                                        <select
                                                            onChange={(e) =>
                                                                setretryStatus(e.target.value)
                                                            }
                                                            className="form-control"
                                                            value={retryStatus}
                                                        >
                                                            <option value="">All Retry Status</option>
                                                            <option value="0">Pending</option>
                                                            <option value="1">Sent</option>
                                                            <option value="2">Delivered</option>
                                                            <option value="3">Undelivered</option>
                                                            <option value="4">Failed</option>
                                                            <option value="5">
                                                                Delivery Unknown
                                                            </option>
                                                            <option value="6">
                                                                Delivery Unconfirmed
                                                            </option>
                                                            <option value="7">Unknown Gateway</option>
                                                        </select>
                                                    </th>
                                                    <th></th>
                                                    <th></th>
                                                    <th></th>
                                                    <th></th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {loading ? (
                                                    <tr><td colSpan={14} height={100}><div className="text-center"><div className="loader"></div></div></td></tr>
                                                ) : !smscampaignlistreportdata || smscampaignlistreportdata.length === 0 ? (
                                                    <tr><td colSpan={14} height={50}><div className="text-center"><p className='mb-0 fs-5 fw-semibold'>No data found</p></div></td></tr>
                                                ) : (
                                                    recordreport.map((item: any, index: number) => (
                                                        <tr key={item.id}>
                                                            <td className='ps-3'>{(currentPage - 1) * limit + index + 1}</td>
                                                            <td>{item.sms_gateway?.name || '-'}</td>
                                                            <td>{item.sms_gateway?.gateway_id === 1 ? 'Twilio' : 'Telnyx'}</td>
                                                            < td > {item.sms_gateways_number?.gateway_number || '-'}</td>
                                                            <td>{item.receiver_number}</td>
                                                            <td className={`text-center ${item?.status === 0 ? 'text-warning fw-bold' :
                                                                item?.status === 1 ? 'text-success fw-bold' :
                                                                    item?.status === 2 ? 'text-success fw-bold' :
                                                                        item?.status === 3 ? 'text-danger fw-bold' :
                                                                            item?.status === 4 ? 'text-danger fw-bold' :
                                                                                item?.status === 5 ? 'text-info fw-bold' :
                                                                                    item?.status === 6 ? 'text-info fw-bold' :
                                                                                        item?.status === 7 ? 'text-secondary fw-bold' :
                                                                                            'text-muted'
                                                                }`}>
                                                                {item.status === 0 ? "Pending" :
                                                                    item.status === 1 ? "Sent" :
                                                                        item.status === 2 ? "Delivered" :
                                                                            item.status === 3 ? "Undelivered" :
                                                                                item.status === 4 ? "Failed" :
                                                                                    item.status === 5 ? "Delivery Unknown" :
                                                                                        item.status === 6 ? "Delivery Unconfirmed" :
                                                                                            item.status === 7 ? "Unknown Gateway" : " - "}
                                                            </td>

                                                            <td className='text-center'>{item.attempt || '-'}</td>
                                                            <td className='text-center'>{item.error_code || '-'}</td>
                                                            <td className='text-center'>{item.retry_error_message || '-'}</td>
                                                            <td
                                                                className={`text-center ${item?.retry_status === 0
                                                                    ? "text-warning fw-bold"
                                                                    : item?.retry_status === 1
                                                                        ? "text-success fw-bold"
                                                                        : item?.retry_status === 2
                                                                            ? "text-success fw-bold"
                                                                            : item?.retry_status === 3
                                                                                ? "text-danger fw-bold"
                                                                                : item?.retry_status === 4
                                                                                    ? "text-danger fw-bold"
                                                                                    : item?.retry_status === 5
                                                                                        ? "text-info fw-bold"
                                                                                        : item?.retry_status === 6
                                                                                            ? "text-info fw-bold"
                                                                                            : item?.retry_status === 7
                                                                                                ? "text-secondary fw-bold"
                                                                                                : "text-muted"
                                                                    }`}
                                                            >
                                                                {item.retry_status === 0
                                                                    ? "Pending"
                                                                    : item.retry_status === 1
                                                                        ? "Sent"
                                                                        : item.retry_status === 2
                                                                            ? "Delivered"
                                                                            : item.retry_status === 3
                                                                                ? "Undelivered"
                                                                                : item.retry_status === 4
                                                                                    ? "Failed"
                                                                                    : item.retry_status === 5
                                                                                        ? "Delivery Unknown"
                                                                                        : item.retry_status === 6
                                                                                            ? "Delivery Unconfirmed"
                                                                                            : item.retry_status === 7
                                                                                                ? "Unknown Gateway"
                                                                                                : " - "}
                                                            </td>
                                                            <td className='createdat text-center'>{formatDate(item.retryAt) || "-"}</td>
                                                            <td className='createdat text-center'>{item.retry_error_code || "-"}</td>
                                                            <td className='createdat text-center'>{item.retry_error_message || "-"}</td>
                                                            <td className='createdat text-center'>{formatDate(item.createdAt) || '-'}</td>
                                                        </tr>
                                                    ))
                                                )}
                                            </tbody>
                                        </table>
                                    </div>

                                    {!smscampaignlistreportdata || smscampaignlistreportdata.length === 0 ? (
                                        <div></div>
                                    ) : (
                                        <div className="pagination d-flex flex-wrap justify-content-center align-items-center my-4 mx-3">
                                            <RenderPaginationButtons
                                                info={info}
                                                currentPage={currentPage}
                                                handlePageChange={handlePageChange}
                                            />
                                        </div>
                                    )}
                                </>
                            </div>
                        </div>
                    </div>
                </section >
            </div >
        </div >
    );
}

export default Viewsmscampaignreports;
